/**
 * Hand-off between the signup flow and the success step (`/onboarding/lista`).
 *
 * After login the app switches to the authenticated container, which unmounts the signup flow.
 * What was captured during signup (categories, photos as File objects, product, volume pricing)
 * can't go to storage, so it is kept in memory here until the success step creates it. Survives
 * React remounts within the same page; a full reload drops it (nothing left to create).
 */
let pending = null;

/** @param {string|number} storeId @param {Object} payload { data, productPreviewUrl, levels } */
export const setPendingFinalize = (storeId, payload) => {
    pending = { storeId: String(storeId), ...payload };
};

/** Read without clearing (safe in render / StrictMode double-invoked initializers). */
export const peekPendingFinalize = (storeId) =>
    pending && storeId != null && pending.storeId === String(storeId) ? pending : null;

export const clearPendingFinalize = () => {
    pending = null;
};
